module.exports = __webpack_public_path__ + "img/bus.ce6c2ea2.svg";